import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({
  providedIn: 'root',
})
export class EnvMagellanDevService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: true,
      isMagellan: '1',
      _env: 'magellan-dev',
      _apiUrl: 'https://dev2-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://dev2-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer:
        'https://magellandevadb2c.b2clogin.com/42550978-5a8d-4e41-824c-5c58c72b815e/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint:
        'https://magellandevadb2c.b2clogin.com.b2clogin.com/magellandevadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl:
        'https://magellandevadb2c.b2clogin.com/magellandevadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '75924281-1923-482d-b2b3-9b58048ba9c5',
      _scope:
        'openid profile https://magellandevadb2c.onmicrosoft.com/api/magellan.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl:
        'https://magellandevadb2c.b2clogin.com/magellandevadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://dev2-login.p-cis.com/',
      _signInURL:
        'https://magellandevadb2c.b2clogin.com/magellandevadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO:
        'https://magellandevadb2c.b2clogin.com/magellandevadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl:
        'https://magellandevadb2c.b2clogin.com/magellandevadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink:
        'https://magellandevadb2c.b2clogin.com/magellandevadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _authEndpoint: 'https://magellandevadb2c.b2clogin.com/magellandevadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://magellandevadb2c.b2clogin.com/magellandevadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9aaf',
      _intercomAppId: 'bqgvwybf'
    };
  }
}
